function clearDateTimePage(){
    var visitstorePage = document.getElementById('visitstore__page');
    var VPA01 = document.getElementById('visitstore__page__attention01');
    var VPA02 = document.getElementById('visitstore__page__attention02');
    var DVP = document.getElementById('date__visitstore__page');
    var TVP = document.getElementById('time__visitstore__page');
    var addressZipPage = document.getElementById('address__zip__page');
    var addressPrefecturePage = document.getElementById('address__prefecture__page');
    var addressAreaPage = document.getElementById('address__area__page');
    var addressAddrPage = document.getElementById('address__addr__page');
    var addressBuildingPage = document.getElementById('address__building__page');
    var addressTelPage = document.getElementById('address__tel__page');
      
    var deliveryhomePage = document.getElementById('deliveryhome__page');
    var DDP = document.getElementById('date__deliveryhome__page');
    var TDP = document.getElementById('time__deliveryhome__page');
    
    var btnCheckoutPage = document.getElementById('checkout');
    
    var cartitemCoverPage = document.getElementById('cart-items__cover__page');
    var cartitemCountPage = cartitemCoverPage.childElementCount;
    var cartpageAttention = document.getElementById('CartPage-LiveAttentionText');
    
    function setVSDP(){
    DVP.setAttribute('disabled',true);
    TVP.setAttribute('disabled',true);
    }
    
    function removeVSDP(){
    DVP.removeAttribute('disabled');
    TVP.removeAttribute('disabled');
    }
    
    function setVSAP(){
    addressZipPage.setAttribute('disabled',true);
    addressPrefecturePage.setAttribute('disabled',true);
    addressAreaPage.setAttribute('disabled',true);
    addressAddrPage.setAttribute('disabled',true);
    addressBuildingPage.setAttribute('disabled',true);
    addressTelPage.setAttribute('disabled',true);
    }
    
    function removeVSAP(){
    addressZipPage.removeAttribute('disabled');
    addressPrefecturePage.removeAttribute('disabled');
    addressAreaPage.removeAttribute('disabled');
    addressAddrPage.removeAttribute('disabled');
    addressBuildingPage.removeAttribute('disabled');
    addressTelPage.removeAttribute('disabled');
    }
    
    //郵便番号から住所を自動入力
    function inputAddressPage(){
    let zipInputPage = addressZipPage.value;
    let gUrlPage = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + zipInputPage + '&language=ja&key=AIzaSyCY_NCiYIeSixpOfsH42LTE1SdXrxLyoWw';
    let zipAttentionPage = document.getElementById('zip-error-page');
    
    fetch(gUrlPage)
        .then(response => response.json())
        .then(data => {
           zipAttentionPage.textContent = '';
          var AddDataLength = data.results.length;
          var AddData = data.results[0].address_components;
          var AddDataPrefecture;
          function selectPrefecturePage(){
            for(PDL = 0; PDL < addressPrefecturePage.options.length; PDL++){
              var PValue = addressPrefecturePage.options[PDL].value;
              if(AddDataPrefecture == PValue){
                addressPrefecturePage.selectedIndex = PDL;
              }
            }
          }
          
          if(AddData.length == 3){
            AddDataPrefecture = AddData[1]['long_name'];
            selectPrefecturePage();
            addressAreaPage.value = '';
            addressAddrPage.value = '';
          }else if(AddData.length == 4){
            AddDataPrefecture = AddData[2]['long_name'];
            selectPrefecturePage();
            addressAreaPage.value = AddData[1]['long_name'];
            addressAddrPage.value = '';
          }else if(AddData.length == 5){
            AddDataPrefecture = AddData[3]['long_name'];
            selectPrefecturePage();
            addressAreaPage.value = AddData[2]['long_name'];
            addressAddrPage.value =  AddData[1]['long_name'];
          }else if(AddData.length == 6){
            AddDataPrefecture = AddData[4]['long_name'];
            selectPrefecturePage();
            addressAreaPage.value = AddData[3]['long_name'];
            addressAddrPage.value =  AddData[2]['long_name'] + AddData[1]['long_name'];
          }
    
        })
      .catch(error => {
        console.error('通信に失敗しました', error);
        zipAttentionPage.textContent = '申し訳ございません。住所が見つかりませんでした。';
        addressPrefecturePage.selectedIndex = 0;
        addressAreaPage.value = '';
        addressAddrPage.value = '';
      });
    }
    
    //ドロワーカートの商品数をチェック
    function checkcartItemNumPage(){
    var cartitemCoverPage = document.getElementById('cart-items__cover__page');
    var cartitemCountPage = cartitemCoverPage.childElementCount;
    var cartpageAttention = document.getElementById('CartPage-LiveAttentionText');
    console.log(cartitemCountPage);
    if(cartitemCountPage > 1) {
      btnCheckoutPage.setAttribute('disabled',true);
      cartpageAttention.classList.remove('visually-hidden');
    }else{
      btnCheckoutPage.removeAttribute('disabled');
      cartpageAttention.classList.add('visually-hidden');
    }
    }
    
    checkcartItemNumPage();
    
    visitstorePage.addEventListener('change',function(){
      if(this.checked == true) {
        DDP.value = "";
        TDP.selectedIndex = 0;
        VPA01.removeAttribute('disabled');
        VPA02.removeAttribute('disabled');
        btnCheckoutPage.setAttribute('disabled',true);
      }
    });
    
    VPA01.addEventListener('change',function(){
      if(this.checked == true) {
        if(VPA02.checked == true) {
          removeVSDP();
          removeVSAP();
          if(DVP.value !== "" && TVP.value !== "" && addressZipPage.value !== "" && addressPrefecturePage.value !== "" && addressAreaPage.value !== "" && addressAddrPage.value !== "" && addressTelPage.value !== "" && cartitemCountPage === 1){
            btnCheckoutPage.removeAttribute('disabled');
          }else{
            btnCheckoutPage.setAttribute('disabled',true);
          }
        }else{
          setVSDP();
          setVSAP();
          btnCheckoutPage.setAttribute('disabled',true);
        }
      }else{
        setVSDP();
        setVSAP();
        btnCheckoutPage.setAttribute('disabled',true);
      }
    });
    
    VPA02.addEventListener('change',function(){
      if(this.checked == true) {
        if(VPA01.checked == true) {
          removeVSDP();
          removeVSAP();
          if(DVP.value !== "" && TVP.value !== "" && addressZipPage.value !== "" && addressPrefecturePage.value !== "" && addressAreaPage.value !== "" && addressAddrPage.value !== "" && addressTelPage.value !== "" && cartitemCountPage === 1){
            btnCheckoutPage.removeAttribute('disabled');
          }else{
            btnCheckoutPage.setAttribute('disabled',true);
          }
        }else{
          setVSDP();
          setVSAP();
          btnCheckoutPage.setAttribute('disabled',true);
        }
      }else{
        setVSDP();
        setVSAP();
        btnCheckoutPage.setAttribute('disabled',true);
      }
    });
        
    DVP.addEventListener('change',function(){
      if(this.value === "" && TVP.value === "" && addressZipPage.value === "" && addressPrefecturePage.value === "" && addressAreaPage.value === "" && addressAddrPage.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(this.value === "" || TVP.value === "" || addressZipPage.value === "" || addressPrefecturePage.value === "" || addressAreaPage.value === "" || addressAddrPage.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
        
    TVP.addEventListener('change',function(){
      if(this.value === "" && DVP.value === "" && addressZipPage.value === "" && addressPrefecturePage.value === "" && addressAreaPage.value === "" && addressAddrPage.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(this.value === "" || DVP.value === "" || addressZipPage.value === "" || addressPrefecturePage.value === "" || addressAreaPage.value === "" || addressAddrPage.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
    
    addressZipPage.addEventListener('input',function(){
       if(DVP.value === "" && TVP.value === "" && this.value === "" && addressPrefecturePage.value === "" && addressAreaPage.value === "" && addressAddrPage.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(DVP.value === "" || TVP.value === "" || this.value === "" || addressPrefecturePage.value === "" || addressAreaPage.value === "" || addressAddrPage.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
      setTimeout(function(){
        inputAddressPage();
      },2000);
    });
    
    addressPrefecturePage.addEventListener('change',function(){
       if(DVP.value === "" && TVP.value === "" && addressZipPage.value === "" && this.value === "" && addressAreaPage.value === "" && addressAddrPage.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(DVP.value === "" || TVP.value === "" || addressZipPage.value === "" || this.value === "" || addressAreaPage.value === "" || addressAddrPage.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
    
    addressAreaPage.addEventListener('input',function(){
       if(DVP.value === "" && TVP.value === "" && addressZipPage.value === "" && addressPrefecturePage.value === "" && this.value === "" && addressAddrPage.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(DVP.value === "" || TVP.value === "" || addressZipPage.value === "" || addressPrefecturePage.value === "" || this.value === "" || addressAddrPage.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
    
    addressAddrPage.addEventListener('input',function(){
       if(DVP.value === "" && TVP.value === "" && addressZipPage.value === "" && addressPrefecturePage.value === "" && addressAreaPage.value === "" && this.value === "" && addressTelPage.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(DVP.value === "" || TVP.value === "" || addressZipPage.value === "" || addressPrefecturePage.value === "" || addressAreaPage.value === "" || this.value === "" || addressTelPage.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
    
    addressTelPage.addEventListener('input',function(){
       if(DVP.value === "" && TVP.value === "" && addressZipPage.value === "" && addressPrefecturePage.value === "" && addressAreaPage.value === "" && addressTelPage.value === "" && this.value === "" && cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else if(DVP.value === "" || TVP.value === "" || addressZipPage.value === "" || addressPrefecturePage.value === "" || addressAreaPage.value === "" || addressTelPage.value === "" || this.value === "" || cartitemCountPage > 1){
          btnCheckoutPage.setAttribute('disabled',true);
      }else{
        btnCheckoutPage.removeAttribute('disabled');
      }
    });
    
    
    
    deliveryhomePage.addEventListener('change',function(){
      if(this.checked == true && cartitemCountPage === 1) {
        DVP.value = "";
        TVP.selectedIndex = 0;
        VPA01.checked = false;
        VPA02.checked = false;
        addressZipPage.value = "";
        addressPrefecturePage.selectedIndex = 0;
        addressAreaPage.value = "";
        addressAddrPage.value = "";
        addressBuildingPage.value = "";
        addressTelPage.value = "";
        VPA01.setAttribute('disabled',true);
        VPA02.setAttribute('disabled',true);
        setVSDP();
        setVSAP();
        btnCheckoutPage.removeAttribute('disabled');
      }else if(this.checked == true && cartitemCountPage > 1) {
        DVP.value = "";
        TVP.selectedIndex = 0;
        VPA01.checked = false;
        VPA02.checked = false;
        addressZipPage.value = "";
        addressPrefecturePage.selectedIndex = 0;
        addressAreaPage.value = "";
        addressAddrPage.value = "";
        addressBuildingPage.value = "";
        addressTelPage.value = "";
        VPA01.setAttribute('disabled',true);
        VPA02.setAttribute('disabled',true);
        setVSDP();
        setVSAP();
      }
    });


    // アンケート機能
    // 必須化でなくなったのでコメントアウト
    // const questionnaire = document.getElementById('questionnaire');
    // const gender = document.getElementById("gender");
    // const age = document.getElementById("age");  

    // if( questionnaire != null ) {    
    //   function toggleCheckoutButton() {
    //     if (gender.value !== "" && age.value !== "") {
    //       btnCheckoutPage.classList.remove('is-disabled'); 
    //     } else {
    //       btnCheckoutPage.classList.add('is-disabled'); 
    //     }
    //   }
    //   gender.addEventListener("change", toggleCheckoutButton);
    //   age.addEventListener("change", toggleCheckoutButton);
    
    //   // 初期状態のチェック
    //   toggleCheckoutButton();
    // }    
    
}
